// 字体大小、边距适配 || defaultWidth 设计稿宽度
export const fitChartSize = (size,defaultWidth=1920) => {
  let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
  if(!clientWidth) return size // 获取不到浏览器宽度时，返回原值

  let scale = clientWidth / defaultWidth
  return Number((size*scale).toFixed(3));
}
